import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { famCrosslink } from '../../../fragments/CrosslinkFragment'
import { famRecipe } from '../../../fragments/RecipeFragment'
import { famCoverImages } from '../../../fragments/CoverImages'

const query = gql`
  query settings {
    settings {
      did_you_know
      did_you_know_plate_change
      push_register_image
      push_register_image_alt
      sso_login_url
      sso_logout_url
      sso_account_url
      crosslink_planning {
        ...famCrosslink
      }
      crosslink_recipes {
        ...famCrosslink
      }
      featured {
        title
        description
        content {
          ... on CustomFeaturedContent {
            __typename
            type
            title
            image
            url
          }
          ... on Recipe {
            ...famRecipe
            __typename
          }
          ... on FeaturedTag {
            tag {
              name
              type
            }
            image
          }
        }
      }
      covers {
        planning {
          ...famCoverImages
        }
        recipes_list {
          ...famCoverImages
        }
      }
    }
  }
  ${famRecipe}
  ${famCrosslink}
  ${famCoverImages}
`

const transformer = ({ settings }: any): any => settings

type variables = any

export default queryServiceCreator<variables>(query, transformer)
